<template>
  <div class="centerpage">
    <div class="bigpicstylecenter">
      <div class="topcentercon">
        <div class="cardinfo clearfix">
          <div class="homecode">
            <img class="twocode" :src="headimgurl">
          </div>
          <div class="homecode codeinfo clearfix">
              <p>{{userinfo.Name}}&nbsp;&nbsp;&nbsp;{{userinfo.Sex}}</p>
              <P>档案号：{{userinfo.PatNo}}</P>
          </div>
        </div>
        <div class="cut" @click="swith">
          <img src="../../assets/images/qiehuan.png" class="qiehuan" alt>
          <span>切换就诊卡</span>
        </div>
      </div>
    </div>
    <div class="centernav">
      <div @click="recordFun">
        <p>
          <img src="../../assets/images/cenpic1.png" alt>
        </p>
        <p>挂号记录</p>
      </div>
      <div class="borderadd" @click="medicalRecord ">
        <p>
          <img src="../../assets/images/cenpic2.png" alt>
        </p>
        <p>就诊记录</p>
      </div>
      <div @click="payRecord">
        <p>
          <img src="../../assets/images/cenpic3.png" alt>
        </p>
        <p>缴费记录</p>
      </div>
      <div @click="query">
        <p>
          <img src="../../assets/images/repsearch.png" alt>
        </p>
        <p>报告查询</p>
      </div>
    </div>

    <!-- 遮罩弹窗 -->
    <div class="PersonPop" v-show="isshow">
      <div class="popcon">
        <div class="topbig"></div>
        <div class="popdeteil">
          <p>张三分</p>
          <p>1233333221</p>
          <img src="../../assets/images/codedel.png" alt class="codedel" @click="codedelfun">
        </div>
        <div class="popcode">
          <div>
            <img src="../../assets/images/twocode.png" alt>
          </div>
          <p>二维码可用于签到</p>
        </div>
      </div>
    </div>
    <!-- 结束 -->
  </div>
</template>
<script>
import {GetWXUserInfo} from "@/services/getData.js";
export default {
  name: "personal-center",
  data() {
    return {
      isshow: false,
      userinfo: {},
      headimgurl: ""
    };
  },
  created: function() {
    this.userinfo = this.$store.state.userInfo;
    this.getWXUserInfo();
  },
  methods: {
    getWXUserInfo() {
      GetWXUserInfo().then(response => {
        this.headimgurl = response.data.headimgurl;
      });
    },
    swith() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard", params: { userId: 123 } });
    },
    isshowfun() {
      this.isshow = !this.isshow;
    },
    recordFun() {
      //跳转到挂号记录
      this.$router.push({ path: "/person/record", params: {} });
    },
    medicalRecord() {
      //跳转到就诊记录
      this.$router.push({ path: "/person/medic", params: {} });
    },
    payRecord() {
      //跳转到缴费记录
      this.$router.push({ path: "/person/paymentrecord", params: {} });
    },
    query() {
      //跳转到报告查询
      this.$router.push({ path: "/report/query", params: {} });
    },
    codedelfun() {
      this.isshow = false;
    }
  }
};
</script>
<style>
.centerpage {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.centerpage .bigpicstylecenter {
  background: url("../../assets/images/beijing.png") no-repeat,
    rgba(242, 242, 242, 1);
  background-size: 100% 66%;
}
.centerpage .bigpicstylecenter > .topcentercon {
  flex: 1;
  margin: 0.2rem;
  border: 0.4rem;
  border-color: #dddddd;
  height: 2.4rem;
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  position: relative;
  box-shadow: 0 0.03rem 0.08rem 0 rgba(200, 214, 223, 1);
  border-radius: 0.08rem;
}
.centerpage .cardinfo {
  padding-left: 0.38rem;
  padding-bottom: 0.28rem;
  border-bottom: 0.01rem dotted #dcdcdc;
}
.centerpage .topcentercon .twocode {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  /* margin-left: 0.38rem; */
  position: relative;
  margin-top: 0.3rem;
  margin-right: 0.29rem;
  border-radius: 0.15rem;
}
.centerpage .topcentercon .codeexplan {
  position: absolute;
  font-size: 0.16rem;
  color: #333333;
  left: 0.25rem;
}
.centerpage .codeinfo > p:first-child {
  color: #333333;
  font-size: 0.3rem;
  text-align: left !important;
  margin-top: 0.42rem;
}
.centerpage .codeinfo > p:last-child {
  color: #999999;
  font-size: 0.3rem;
  text-align: left !important;
}
.centerpage .topcentercon .cut {
  box-sizing: border-box;
  padding-top: 0.2rem;
}

.centerpage .qiehuan {
  width: 0.32rem;
  height: 0.32rem;
  display: inline-block;
  vertical-align: text-bottom;
}

.centerpage .homecode {
  float: left;
}

.centerpage .centernav {
  /* flex: 1;
  display: flex;
  flex-direction: row; */
  background: white;
  box-sizing: border-box;
  text-align: center;
}

.centerpage .centernav > div {
  /* flex: 1; */
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  width: 50%;
  position: relative;
  border-bottom: 0.01rem solid #f2f2f2;
  float: left;
  padding: 0.18rem 0;
}

.centerpage .centernav > div::after {
  display: inline-block;
  content: "";
  position: absolute;
  border: 0.01rem solid #f2f2f2;
  left: 0;
  height: 100%;
  top: -0.02rem;
}

.centerpage .centernav > div > p > img {
  width: 0.48rem;
  height: 0.46rem;
  margin: 0 auto;
}
/* .centerpage .borderadd {
  border-left: 1px solid rgba(229, 229, 229, 1);
  border-right: 1px solid rgba(229, 229, 229, 1); */
/* } */
/* 遮罩弹窗样式 */
.centerpage .PersonPop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.centerpage .PersonPop .popcon {
  width: 4.19rem;
  height: 5.21rem;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -2.08rem;
  margin-top: -2.605rem;
}

.centerpage .PersonPop .popcon .topbig {
  width: 100%;
  height: 0.1rem;
  background-color: #1592e4;
}

.centerpage .PersonPop .popcon .popdeteil {
  padding-left: 0.28rem;
  padding-top: 0.23rem;
  font-size: 0.24rem;
  color: #333333;
  border-bottom: 0.01rem solid #dcdcdc;
  padding-bottom: 0.19rem;
  font-family: "MicrosoftYaHei";
  position: relative;
}

.centerpage .PersonPop .popcon .popdeteil .codedel {
  position: absolute;
  width: 0.42rem;
  height: 0.42rem;
  right: 0.2rem;
  top: 0.2rem;
}

.centerpage .PersonPop .popcon .popcode {
  text-align: center;
  font-size: 0.2rem;
  color: #333333;
  padding: 0.32rem 0.64rem 0.1rem 0.63rem;
}

.centerpage .PersonPop .popcon .popcode img {
  display: inline-block;
  width: 2.92rem;
  height: 2.92rem;
}

/* 遮罩弹窗样式 结束*/
</style>



// WEBPACK FOOTER //
// src/components/person/personal-center.vue